import React, { useEffect, useState } from "react";
import styles from './postJob.module.css'
import { getsessionStorage, getStorage, setsessionStorage } from "../../../utils";
import constant from "../../../constant";
import StepOne from "../../../Component/Oppurtunity/stepOne";
import { JobDetailById, postJobSteps } from "../../../action/jobs";
import { toast } from "react-toastify";
import Header from '../../../Component/Common/Header/JobPosting'
import StepTwo from "../../../Component/Oppurtunity/stepTwo";
import StepThree from '../../../Component/Oppurtunity/stepThree'
import StepFour from '../../../Component/Oppurtunity/stepFour'
import StepFive from "../../../Component/Oppurtunity/stepFive";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const JobPost = () => {
    const history = useHistory()
    const [ud, setUd] = useState(null);
    const [data, setData] = useState(null)

    useEffect(() => {
        // Get the user details from storage
        let storage = getStorage(constant.keys.userDetails);

        // Decode the base64 string back to a JSON object
        storage = JSON.parse(atob(storage)); // atob() is used to decode from base64
        // Set the decoded object as the user details
        setUd(storage);

    }, []);

    const [step, setStep] = useState(1);
    useEffect(() => {
        const storage = getsessionStorage(constant.keys.jobPostingSession);
        if (storage?.step) {
            setStep(storage.step)
        }
        if (storage?.id) {
            JobDetailById(storage?.id).then((res) => {
                if (res.status) {
                    setData(res.result)
                } else {
                    toast.error(res.error)

                }
            });
        }
    }, [step])
    const nextStep = () => {
        const storage = getsessionStorage(constant.keys.jobPostingSession);
        setsessionStorage(constant.keys.jobPostingSession, { id: storage?.id, step: step < 5 ? step + 1 : step });

        setStep((prev) => (prev < 5 ? prev + 1 : prev));
    };


    const prevStep = () => {
        const storage = getsessionStorage(constant.keys.jobPostingSession);
        setsessionStorage(constant.keys.jobPostingSession, { id: storage?.id, step: step > 1 ? step - 1 : step });

        setStep((prev) => (prev > 1 ? prev - 1 : prev));
    };


    const onSubmit = (payload) => {
        return postJobSteps(payload, step).then((res) => { // Return the Promise
            if (res.status) {
                setsessionStorage(constant.keys.jobPostingSession, { id: res.result.jobId, step: step + 1 });
                nextStep();
                toast.success(res.result.message);
            } else {
                toast.error(res.error);
            }
        });
    };


    const onFinalSubmit = (payload) => {
        postJobSteps(payload, 5).then((res) => {
            if (res.status) {
                history.push(constant.component.dashboard.url)
                toast.success(res.result.message);
            } else {
                toast.error(res.error);
            }
        })
    }
    return (
        <React.Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="my-3 p-2 row">
                    <div className="col-md-12">
                        <div className="card border-0 shadow-ctm bg-light rounded-3">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className={`${styles['post-box']} mb-4 mt-3`}>
                                            <h2 className={`${styles['post-title']}`}>Post A New Requirement</h2>
                                            <p className="mb-0"><span className={`${styles['span-title']}`}>for</span> <span className={`${styles['sub-title']}`}>{ud?.COMPANY_NAME}</span></p>
                                        </div>
                                        <div className={`${styles['inner-post']}`}>
                                            {/* Step Navigation */}
                                            <ul className="nav nav-pills nav-justified navjob-pills mb-4">
                                                <li className="nav-item">
                                                    <a className={`nav-link ${step === 1 ? "active" : ""}`} href="#"><span className='nav-span'>1</span><span className={`${styles['bgwhite-ctm']} px-2`}>Requirement Details</span></a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${step === 2 ? "active" : ""}`} href="#"><span className='nav-span'>2</span><span className={`${styles['bgwhite-ctm']} px-2`}>Candidate Recruitment</span></a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${step === 3 ? "active" : ""}`} href="#"><span className='nav-span'>3</span><span className={`${styles['bgwhite-ctm']} px-2`}>Interview Details</span></a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${step === 4 ? "active" : ""}`} href="#"><span className='nav-span'>4</span><span className={`${styles['bgwhite-ctm']} px-2`}>Preview</span></a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className={`nav-link ${step === 5 ? "active" : ""}`} href="#"><span className='nav-span'>5</span><span className={`${styles['bgwhite-ctm']} px-2`}>Submit</span></a>
                                                </li>
                                            </ul>

                                            <div className={`${styles['box-inner']}`}>
                                                {/* Form Steps */}
                                                <div className="card shadow-ctm border-0 rounded-3">
                                                    <div className="card-body">
                                                        {step === 1 && (
                                                            <StepOne
                                                                company_name={ud?.COMPANY_NAME}
                                                                styles={styles}
                                                                detail={data}
                                                                onSubmit={onSubmit}
                                                            />
                                                        )}
                                                        {step === 2 && data && (
                                                            <StepTwo
                                                                styles={styles}
                                                                onSubmit={onSubmit}
                                                                detail={data}
                                                                prevStep={prevStep}
                                                            />
                                                        )}
                                                        {step === 3 && (
                                                            <StepThree
                                                                oppurtunityType={data?.OPPURTUNITY_TYPE}
                                                                styles={styles}
                                                                onSubmit={onSubmit}
                                                                detail={data}
                                                                prevStep={prevStep}
                                                            />
                                                        )}
                                                        {step === 4 && (
                                                            <StepFour
                                                                styles={styles}
                                                                detail={data}
                                                                prevStep={prevStep}
                                                                nextStep={nextStep}

                                                            />
                                                        )}
                                                        {step === 5 && (
                                                            <StepFive
                                                                styles={styles}
                                                                detail={data}
                                                                onSubmit={onFinalSubmit}
                                                            />
                                                        )}
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
}

export default JobPost